import { useTranslation } from "react-i18next";
import { Box, InputAdornment, TextField } from "@mui/material";

import { SearchIcon } from "../../../assets/icons/chat-page-icons";

const ChatSearchBar = ({
  searchValue,
  handleOnSearch,
  isChatLoading,
}: {
  searchValue: string;
  handleOnSearch: (value: string) => void;
  isChatLoading: boolean;
}) => {
  const { t } = useTranslation("chat");

  return (
    <Box sx={styles.searchBarContainer}>
      <TextField
        placeholder={t("search")}
        variant="outlined"
        value={searchValue}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => handleOnSearch(event.target.value)}
        slotProps={{
          input: {
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          },
        }}
        sx={styles.searchBar}
        disabled={isChatLoading}
      />
    </Box>
  );
};

export default ChatSearchBar;

const styles = {
  searchBarContainer: {
    px: "15px",
    marginBottom: "17px",
    width: "100%",
  },
  searchBar: {
    width: "100%",
    "& .MuiInputBase-root": {
      columnGap: "10px",
    },
  },
};
